import React, { useEffect, useState } from "react";
import { Form, Col, Button } from "react-bootstrap";
import useSelectProyecto from "../../../../hooks/useSelectProyectos";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormik } from "formik";
import { useHistory } from "react-router-dom";

const FiltroProyectos = ({ setValores, loading }) => {
  const [error, setError] = useState(null);
  const history = useHistory();
  const queryString = new URLSearchParams(window.location.search);
  const idProyectoQ = queryString.get("proyecto");

  const [proyectoSelect, SelecProyectos] = useSelectProyecto(idProyectoQ);
  const formik = useFormik({
    initialValues: {
      idEvento: idProyectoQ || null,
    },
    onSubmit: (valores) => {
      history.push(`?proyecto=${valores.idEvento}`);
    },
  });

  useEffect(() => {
    if (idProyectoQ) {
      setValores({
        idEvento: idProyectoQ,
      });
    }
  }, [idProyectoQ]);

  useEffect(() => {
    if (proyectoSelect) {
      setError(null);
      formik.setFieldValue("idEvento", proyectoSelect.id_proyecto);
    } else {
      formik.setFieldValue("idEvento", null);
    }
  }, [proyectoSelect]);

  useEffect(() => {
    const valores = {
      idEvento: idProyectoQ || null,
    };
    history.push(`?proyecto=${valores.idEvento}`);
  }, []);

  return (
    <div className="FormularioFiltroMatricula">
      <Form onSubmit={formik.handleSubmit}>
        <Form.Row>
          <Form.Group as={Col} md={3}>
            <Form.Label>Productos</Form.Label>
            <SelecProyectos />
            {error && <Form.Text className="text-danger">{error}</Form.Text>}
          </Form.Group>
          <Form.Group as={Col} md={6} className="d-flex align-items-end">
            <Button type="submit" disabled={loading} className="btn-icon">
              <FontAwesomeIcon icon={faSearch} />
              Buscar
            </Button>
          </Form.Group>
        </Form.Row>
      </Form>
    </div>
  );
};

export default FiltroProyectos;
